@for (child of items(); track child) {
@if('children' in child) {
<li link-tree-branch [item]="child" [depth]="depth()"></li>
}
@else {
<li link-tree-leaf [link]="child" [depth]="depth()"></li>
}
}